import React from 'react';
import { withTranslation } from 'react-i18next';

import NewsletterSignUp from '../forms/NewsletterSignUp';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import SocialMediaIcons from '../content/SocialMediaIcons';
import './NewsletterSignUpSection.module.css';

const NewsletterSignUpSection = ({ t }) => (
  <Grid direction="x">
    <Cell largeSize={24}>
      <div styleName="newsletter-section">
        <div styleName="heading">{t('More 3D Printing Stories')}</div>
        <div styleName="tagline">
          {t('Join thousands of newsletter subscribers.')}
          <br />
          {t(
            'Sign up to receive the latest 3D printing stories in your inbox every month.'
          )}
        </div>
        <NewsletterSignUp layoutType="footer" />
        <div styleName="social-media-icons">
          <SocialMediaIcons />
        </div>
      </div>
    </Cell>
  </Grid>
);

export default withTranslation()(NewsletterSignUpSection);
